(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /**
   * El drawer usa <dialog> nativo a propósito: showModal() ya trae trampa de
   * foco, cierre con Escape, fondo inerte y backdrop. Lo único que queda por
   * escribir es la transición y el anuncio para lector de pantalla.
   */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.live = this.querySelector('[data-drawer-live]');

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-drawer-close]')) this.close();
        // Clic en el backdrop: el <dialog> es el propio target.
        if (event.target === this.dialog) this.close();
      });

      document.addEventListener('nanah:drawer:open', () => this.open());
      document.addEventListener('nanah:cart:updated', () => this.announce());

      // Los disparadores viven fuera del drawer (el ícono del header, la barra
      // pegajosa) y sus secciones se repintan, así que se delega en document.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-drawer-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open();
      });

      // El cierre nativo por Escape no pasa por close(): deja la clase puesta.
      this.dialog.addEventListener('close', () => this.dialog.classList.remove('is-open'));
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');

      const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducido) {
        this.dialog.close();
        return;
      }
      // transitionend puede no dispararse si la pestaña pierde foco a mitad;
      // el temporizador es el seguro para que el diálogo no quede colgado.
      let cerrado = false;
      const cerrar = () => {
        if (cerrado) return;
        cerrado = true;
        this.dialog.close();
      };
      this.dialog.addEventListener('transitionend', cerrar, { once: true });
      setTimeout(cerrar, 400);
    }

    /** Patrón limpiar-y-poner: sin el vaciado previo el anuncio no se repite. */
    announce() {
      const mensaje = this.querySelector('[data-envio-mensaje]');
      if (!this.live || !mensaje) return;
      const texto = mensaje.textContent.trim();
      this.live.textContent = '';
      requestAnimationFrame(() => {
        this.live.textContent = texto;
      });
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Mejora progresiva de los filtros nativos.
   *
   * Los chips ya son enlaces con la URL que calculó Shopify, así que sin esto
   * filtran igual con una recarga. Esto sólo evita la recarga: pide la misma
   * URL con `section_id`, cambia el contenido y actualiza la barra de
   * direcciones. Si el fetch falla, se deja que el enlace navegue.
   */
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.seccion = this.querySelector('[data-collection-section]');
      if (!this.seccion) return;
      this.id = this.seccion.getAttribute('data-collection-section');

      this.addEventListener('click', (event) => {
        const chip = event.target.closest('.fchip[href], .col__vacio a[href]');
        if (!chip || event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        this.filtrar(chip.getAttribute('href'));
      });

      window.addEventListener('popstate', () => this.filtrar(window.location.href, false));
    }

    async filtrar(url, empujar = true) {
      const destino = new URL(url, window.location.origin);
      this.seccion.setAttribute('aria-busy', 'true');

      try {
        const separador = destino.search ? '&' : '?';
        const respuesta = await fetch(destino.pathname + destino.search + separador + 'section_id=' + this.id);
        if (!respuesta.ok) throw new Error('HTTP ' + respuesta.status);

        const doc = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
        const nuevo = doc.querySelector('[data-collection-section]');
        if (!nuevo) throw new Error('la respuesta no trae el contenedor de la sección');

        this.seccion.innerHTML = nuevo.innerHTML;
        if (empujar) window.history.pushState({}, '', destino.pathname + destino.search);
        // El foco vuelve al riel: quien filtró con teclado no queda perdido.
        this.querySelector('.fchip')?.focus({ preventScroll: true });
      } catch (error) {
        // No se traga: se registra y se navega, que es el camino que ya existía.
        console.error('[nanah:filtros] no se pudo filtrar sin recargar:', error);
        window.location.href = destino.href;
      } finally {
        this.seccion.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * Ficha de compra: cantidad, escalera de packs y barra pegajosa.
   *
   * Todos los precios que se muestran vienen ya formateados por Liquid en los
   * data de cada opción. La única excepción es la etiqueta del botón, que
   * multiplica precio por cantidad: ahí sí hay que formatear en el cliente, y
   * se hace con el formato real de la tienda, nunca con uno inventado.
   */
  class ProductBuy extends HTMLElement {
    connectedCallback() {
      this.cantidad = 1;
      this.centavos = Number(this.querySelector('[data-atc]')?.getAttribute('data-centavos') || 0);

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-pdp-menos]')) return this.cambiar(-1);
        if (event.target.closest('[data-pdp-mas]')) return this.cambiar(1);
        const opcion = event.target.closest('.lopt');
        if (opcion) this.elegirPack(opcion);
      });

      this.armarBarra();
      this.contarGaleria();
      this.armarZoom();
    }

    cambiar(delta) {
      this.cantidad = Math.max(1, this.cantidad + delta);
      const salida = this.querySelector('[data-pdp-cant]');
      if (salida) salida.textContent = this.cantidad;
      const menos = this.querySelector('[data-pdp-menos]');
      if (menos) menos.disabled = this.cantidad <= 1;
      this.sincronizar();
    }

    elegirPack(opcion) {
      this.querySelectorAll('.lopt').forEach((o) => o.setAttribute('aria-checked', String(o === opcion)));
      this.centavos = Number(opcion.getAttribute('data-centavos') || 0);

      const precio = this.querySelector('[data-precio]');
      const lista = this.querySelector('[data-lista] s');
      const off = this.querySelector('[data-off]');
      /* RONDA 9 — `querySelector('[data-equiv]')` devolvía el <p> entero de la
         equivalencia, porque va antes que los botones en el DOM, y asignarle
         textContent le borraba el círculo de color, los iconos de botella y
         toda la estructura. Ahora el atributo vive en el <span> del texto y
         los iconos se redibujan aparte, según la cifra de la frase nueva. */
      const equiv = this.querySelector('.equiv__txt');
      // El money_format de la tienda incluye <span class=money>, así que estos
      // valores son markup, no texto. Vienen de un ajuste de la tienda pasado
      // por Liquid, nunca de entrada de usuario.
      if (precio) precio.innerHTML = opcion.getAttribute('data-precio');
      if (lista) lista.innerHTML = opcion.getAttribute('data-lista');
      if (off) off.textContent = '−' + opcion.getAttribute('data-off') + '%';
      const frase = opcion.getAttribute('data-equiv') || '';
      if (equiv) equiv.textContent = frase;
      /* Los iconos siguen a la frase: se cuentan del número que va después
         del «=», igual que en Liquid, y se redibujan. Si la frase viene vacía
         —un pack sin equivalencia cargada— la fila entera se esconde en vez de
         quedarse con los iconos del pack anterior. */
      const fila = this.querySelector('.equiv');
      const bot = this.querySelector('[data-equiv-bot]');
      if (fila) fila.hidden = frase.trim() === '';
      if (bot && frase) {
        let n = parseInt((frase.split(' = ')[1] || '').trim(), 10);
        if (!Number.isFinite(n) || n < 1) n = 1;
        if (n > 6) n = 6;
        const src = bot.querySelector('img') ? bot.querySelector('img').src : '';
        bot.innerHTML = '';
        for (let i = 0; i < n; i++) {
          const img = document.createElement('img');
          img.src = src;
          img.width = 8;
          img.height = 18;
          img.loading = 'lazy';
          img.alt = '';
          bot.appendChild(img);
        }
      }

      const variante = opcion.getAttribute('data-variante');
      this.querySelectorAll('[data-atc],[data-sticky-atc]').forEach((b) => {
        b.setAttribute('data-cart-add', variante);
      });
      this.sincronizar();
    }

    sincronizar() {
      const total = window.NanahCart.formatoMoneda(this.centavos * this.cantidad);
      this.querySelectorAll('[data-atc],[data-sticky-atc]').forEach((boton) => {
        boton.setAttribute('data-cart-quantity', String(this.cantidad));
        const plantilla = boton.getAttribute('data-etiqueta');
        if (plantilla) boton.innerHTML = plantilla.replace('__TOTAL__', total);
      });
    }

    /**
     * La barra se arma cuando el borde inferior del botón en línea cruza el
     * tope del viewport, no a los N píxeles de scroll: el disparador es haber
     * dejado atrás el botón, y eso depende del alto del contenido, no de una
     * distancia fija.
     *
     * Con IntersectionObserver esto se queda pegado, y está medido: si el botón
     * pasa de estar arriba del viewport a estar abajo en un solo salto — un
     * ancla, un fling con inercia — `isIntersecting` vale false en los dos
     * extremos, el observer no dispara y la barra se queda armada con el botón
     * a la vista. Un listener pasivo estrangulado por rAF lee una sola caja por
     * cuadro y no tiene ese hueco.
     */
    armarBarra() {
      const barra = this.querySelector('[data-sticky]');
      const fila = this.querySelector('[data-atc-row]');
      if (!barra || !fila) return;
      barra.hidden = false;

      let pendiente = false;
      const revisar = () => {
        pendiente = false;
        barra.classList.toggle('is-on', fila.getBoundingClientRect().bottom < 0);
      };
      const programar = () => {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(revisar);
      };

      window.addEventListener('scroll', programar, { passive: true });
      window.addEventListener('resize', programar);
      revisar();
    }

    /**
     * Galería ampliada. Abre en la foto que se tocó, no en la primera: el
     * salto se hace con `scrollLeft` ANTES de `showModal()`, porque un
     * <dialog> cerrado tiene `display:none` y su carrete mide cero. Con
     * `scroll-behavior:auto` forzado no hay animación al abrir.
     */
    armarZoom() {
      const dialogo = this.querySelector('[data-gal-dialogo]');
      if (!dialogo) return;
      const pista = dialogo.querySelector('[data-galz-track]');
      const cuenta = dialogo.querySelector('[data-galz-count]');
      const total = pista ? pista.children.length : 0;

      const irA = (i) => {
        if (!pista) return;
        const previo = pista.style.scrollBehavior;
        pista.style.scrollBehavior = 'auto';
        pista.scrollLeft = pista.clientWidth * i;
        pista.style.scrollBehavior = previo;
        if (cuenta) cuenta.textContent = i + 1 + ' / ' + total;
      };

      this.querySelectorAll('[data-gal-abrir]').forEach((boton) => {
        boton.addEventListener('click', () => {
          const i = Number(boton.getAttribute('data-gal-abrir')) || 0;
          dialogo.showModal();
          irA(i);
        });
      });

      const cerrar = dialogo.querySelector('[data-gal-cerrar]');
      if (cerrar) cerrar.addEventListener('click', () => dialogo.close());

      /* Tocar fuera de la foto cierra. El <dialog> ocupa la pantalla entera,
         así que el backdrop no recibe el click: se compara contra el propio
         diálogo y contra la <figure>, que es el margen alrededor de la foto. */
      dialogo.addEventListener('click', (e) => {
        if (e.target === dialogo || e.target.tagName === 'FIGURE') dialogo.close();
      });

      if (pista && cuenta) {
        pista.addEventListener(
          'scroll',
          () => {
            const i = Math.round(pista.scrollLeft / pista.clientWidth) + 1;
            cuenta.textContent = Math.min(Math.max(i, 1), total) + ' / ' + total;
          },
          { passive: true }
        );
      }
    }

    contarGaleria() {
      const pista = this.querySelector('[data-gal-track]');
      const cuenta = this.querySelector('[data-gal-count]');
      if (!pista || !cuenta) return;
      const total = pista.children.length;

      pista.addEventListener(
        'scroll',
        () => {
          const primera = pista.firstElementChild;
          if (!primera) return;
          // El paso es el ancho real de la figura más el gap, medido, no fijo.
          const paso = primera.getBoundingClientRect().width + 8;
          const i = Math.round(pista.scrollLeft / paso) + 1;
          cuenta.textContent = Math.min(Math.max(i, 1), total) + ' / ' + total;
        },
        { passive: true }
      );
    }
  }

  if (!customElements.get('product-buy')) customElements.define('product-buy', ProductBuy);

  } catch(e) { console.error(e); }
})();
})();
